import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';
import { useLoaderStore } from '@/shared/store/useLoaderStore';

export const useRegionInfo = (
  regionSlug: MaybeRefOrGetter<string>,
  enabled: MaybeRefOrGetter<boolean>,
  countrySlug?: MaybeRefOrGetter<string | string[] | undefined>,
) => {
  const loaderStore = useLoaderStore();

  const { getRegionInfoBySlug } = useExperienceApi();

  const { data: regionInfo } = useQuery({
    queryKey: ['regionInfo', regionSlug],
    queryFn: async () => {
      const result = await getRegionInfoBySlug({ path: { regionSlug: unref(regionSlug) as string } });

      loaderStore.check404(result);

      // Для ссылок вида /tours/united-states/kavkaz/ нужна ручная проверка, что полученный регион совпадает
      // с регионом в url. В противном случае - кидать 404.
      const isRouteSlugReal = result.data?.countries?.some(
        (country) => country.name_en?.toLocaleLowerCase() === unref(countrySlug),
      );

      if (!isRouteSlugReal) {
        loaderStore.is404 = true;
      }

      return result;
    },
    enabled: computed(() => !!unref(enabled)),
    select: (response) => response.data,
    retry: false,
  });

  return {
    regionInfo,
  };
};
